import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, inject } from '@angular/core'
import { OrderInterface } from '@modules/orders-module/interfaces/order.interface'
import { ChangeSimpleOrderComponent } from './common/change-simple-order/change-simple-order.component'
import { ChangeComplexOrderComponent } from './common/change-complex-order/change-complex-order.component'
import { StocksOrdersHelperService } from '@modules/stocks-module/orders/services/stocks-orders-helper.service'

@Component({
	selector: 'app-change-order',
	templateUrl: './change-order.component.html',
	styleUrl: './change-order.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ChangeSimpleOrderComponent, ChangeComplexOrderComponent],
})
export class ChangeOrderComponent {
	@Input() order: OrderInterface | null = null
	@Output() closeDropdown: EventEmitter<void> = new EventEmitter()

	private readonly _ordersStocksHelperService: StocksOrdersHelperService =
		inject<StocksOrdersHelperService>(StocksOrdersHelperService)

	get isComplexOrder(): boolean {
		return this._ordersStocksHelperService.checkIsComplexOrder(this.order)
	}
	protected onCloseDropdown(): void {
		this.closeDropdown.emit()
	}
}
